import { toCamelCaseKeys } from '@iichi/helper/object';
import jsonData from './category.json';

export interface CategoryData {
  categoryId: number;
  parentCategoryId: number;
  sort: number;
  slug: string;
  name: string;
}

const categoryData: CategoryData[] = toCamelCaseKeys(jsonData);

export const categoryIdFood = categoryData.find((cat) => cat.slug === 'food')?.categoryId;

export const categoryIdAlcohol = categoryData.find((cat) => cat.slug === 'alcohol')?.categoryId;

export const categories = ({ parentCategoryId = 0 } = {}): CategoryData[] => categoryData.filter((cat) => cat.parentCategoryId === parentCategoryId).sort((a, b) => a.sort - b.sort);

export const category = ({ categoryId }: { categoryId: number }) => categoryData.find((cat) => cat.categoryId === categoryId);

export const categoryBySlug = ({ parentSlug, slug }: { parentSlug?: string; slug: string }) => {
  let parentCategoryId = 0;
  if (parentSlug) {
    const parentCategory = categoryData.find((cat) => cat.slug === parentSlug && cat.parentCategoryId === 0);
    if (!parentCategory) {
      return;
    }
    parentCategoryId = parentCategory.categoryId;
  }
  return categoryData.find((cat) => cat.slug === slug && cat.parentCategoryId === parentCategoryId);
};

export const getCategoryPath = ({ categoryId }: { categoryId: number }): string => {
  const cat = category({ categoryId });
  if (!cat) {
    return '';
  }

  if (cat.parentCategoryId === 0) {
    return cat.slug;
  }

  const parent = category({ categoryId: cat.parentCategoryId });
  if (!parent) {
    return cat.slug;
  }

  return `${parent.slug}/${cat.slug}`;
};
